import { render, staticRenderFns } from "./TalkMsgAlbumImg.vue?vue&type=template&id=642b69de"
import script from "./TalkMsgAlbumImg.vue?vue&type=script&lang=js"
export * from "./TalkMsgAlbumImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports